import { render } from "./emp_choose.vue?vue&type=template&id=1596fbf1"
import script from "./emp_choose.vue?vue&type=script&lang=js"
export * from "./emp_choose.vue?vue&type=script&lang=js"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__